<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 예산년도 -->
          <c-datepicker
            :range="true"
            type="year"
            defaultStart="-2y"
            defaultEnd="0y"
            label="예산년도"
            name="year"
            v-model="searchParam.years"
          />
        </div>
      </template>
    </c-search-box>
    <!-- 연간 예산편성 목록 -->
    <c-table
      ref="table"
      title="LBL0010321"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safety-health-year-budget',
  data() {
    return {
      searchParam: {
        plantCd: '',
        years: [],
      },
      grid: {
        columns: [
          
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'budgetYear',
            field: 'budgetYear',
            // 예산년도
            label: 'LBL0010320',
            style: 'width:100px',
            align: 'center',
            sortable: true,
            type: 'link',
          },
          {
            name: 'budgetAllAmt',
            field: 'budgetAllAmt',
            // 예산 총 금액(원)
            label: 'LBL0010322',
            style: 'width:250px',
            align: 'right',
            type: 'cost',
            sortable: true,
          },
          {
            name: 'budgetStatusName',
            field: 'budgetStatusName',
            // 진행상태
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: '결재진행단계',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.budget.year.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "LBL0010323"; // 연간 예산편성 상세
      this.popupOptions.param = {
        budgetYearPlanId: row ? row.budgetYearPlanId : '',
      };
      this.popupOptions.target = () => import(`${"./budgetYearPlanDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
